module.exports = __webpack_public_path__ + "img/pluto-bg.e463dabb.jpg";